export const EVENT_PACES = ["quick", "standard", "extended"];
function unique(values) {
    return new Set(values).size === values.length;
}
export function defineGame(definition) {
    if (!/^[A-Z][A-Z0-9_]*$/.test(definition.key))
        throw new Error(`Invalid game key: ${definition.key}`);
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(definition.metadata.slug))
        throw new Error(`Invalid slug for ${definition.key}`);
    if (!definition.metadata.name.trim() || !definition.metadata.description.trim() || definition.metadata.minimumPlayers < 1)
        throw new Error(`Invalid metadata for ${definition.key}`);
    if (definition.metadata.maximumPlayers !== null && definition.metadata.maximumPlayers < definition.metadata.minimumPlayers)
        throw new Error(`Invalid player range for ${definition.key}`);
    if (!unique(definition.metadata.capabilities) || !unique(definition.supportedConfiguration))
        throw new Error(`Duplicate catalog entries for ${definition.key}`);
    if (definition.supportedConfiguration.some((key) => !(key in definition.initialConfig)))
        throw new Error(`Unknown configuration field for ${definition.key}`);
    for (const pace of EVENT_PACES) {
        const profile = definition.configurationProfiles[pace];
        if (!profile || !Number.isInteger(profile.estimatedMinutes) || profile.estimatedMinutes < 1)
            throw new Error(`Invalid ${pace} profile for ${definition.key}`);
        if (Object.keys(profile.configuration).some((key) => !definition.supportedConfiguration.includes(key)))
            throw new Error(`Unsupported ${pace} configuration for ${definition.key}`);
    }
    if (!definition.views.host || !definition.views.player || !definition.views.display)
        throw new Error(`Incomplete views for ${definition.key}`);
    if (!unique(definition.states) || !unique(definition.actions) || !unique(definition.realtime.clientToServer) || !unique(definition.realtime.serverToClient))
        throw new Error(`Duplicate contract entries for ${definition.key}`);
    return Object.freeze(definition);
}
//# sourceMappingURL=game-definition.js.map